import { CommonModule, DecimalPipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FlexLayoutModule } from "@angular/flex-layout";

import {
  MatPaginatorIntl,
  MatPaginatorModule,
} from "@angular/material/paginator";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatMenuModule } from "@angular/material/menu";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatChipsModule } from "@angular/material/chips";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import { MatBadgeModule } from "@angular/material/badge";

import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { PaginatorI18n } from "./paginator-translate/PaginatorI18n";

import { DateTimeModule } from "../date-time/date-time.module";
import { SearchFilterModule } from "../search-filter/search-filter.module";
import { MonthPickerModule } from "../month-picker/month-picker.module";
import { SearchPickerModule } from "../search-picker/search-picker.module";
import { ChipListModule } from "../chip-list/chip-list.module";
import { DatePickerModule } from "../datepicker-range/datepicker-range.module";

import { CustomTableComponent } from "./custom-table.component";
import { ColumnSorterComponent } from "./column-sorter/column-sorter.component";
import { AdvancedFilterComponent } from "./advanced-filter/advanced-filter.component";
import { GridPipeModule } from "../../pipes/grid-pipe/gridPipe.module";
import { OptionsFilterModule } from "../options-filter/options-filter.module";
import { DetailHostDirective } from "./detail-host.directive"; 

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    DragDropModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatMenuModule,
    MatCardModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatChipsModule,
    MatSelectModule,
    MatInputModule,
    MatBadgeModule,
    DateTimeModule,
    MonthPickerModule,
    SearchFilterModule,
    SearchPickerModule,
    ChipListModule,
    DatePickerModule,
    GridPipeModule,
    OptionsFilterModule,
  ],
  declarations: [
    CustomTableComponent,
    AdvancedFilterComponent,
    ColumnSorterComponent,
    DetailHostDirective
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      deps: [TranslateService],
      useFactory: (translateService: TranslateService) =>
        new PaginatorI18n(translateService).getPaginatorIntl(),
    },
    DecimalPipe,
  ],
  exports: [CustomTableComponent, DetailHostDirective],
})
export class CustomTableModule {}
